import I18n from 'I18n';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UISelect from 'UIComponents/input/UISelect';
import { memo } from 'react';
import styled from 'foundations-theming/utils';
import FilterOperatorRollingInequalityInput from './FilterOperatorRollingInequalityInput';
import { useElementSize } from '../../hooks/useElementSize';
import { GAP, INPUT_WIDTHS_EDITOR_CONDITION, ROW_GAP } from '../../constants/inlineLayout';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SinglePanelInputContainer = styled.div.withConfig({
  displayName: "FilterOperatorRollingInequalityInputOperatorSelect__SinglePanelInputContainer",
  componentId: "sc-1nf5lgc-0"
})(["display:flex;flex-wrap:wrap;column-gap:", "px;row-gap:", "px;"], GAP, ROW_GAP);
const SinglePanelOperatorSelectContainer = styled.div.withConfig({
  displayName: "FilterOperatorRollingInequalityInputOperatorSelect__SinglePanelOperatorSelectContainer",
  componentId: "sc-1nf5lgc-1"
})(({
  size
}) => ({
  width: size === 'sm' ? '100%' : `${INPUT_WIDTHS_EDITOR_CONDITION[size]}px`
}));
const FilterOperatorRollingInequalityInputOperatorSelect = props => {
  const {
    condition,
    disabled,
    onChange,
    readOnly,
    useOnePanel,
    inputUse
  } = props;
  const {
    width
  } = useElementSize();
  const options = [{
    text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.dateTypeSelection.dynamic'),
    value: false
  }, {
    text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.dateTypeSelection.dynamicAnniversary'),
    value: true
  }];
  const handleOperatorTypeChange = evt => {
    onChange(syntheticEvent(condition.set('ignoreYear', evt.target.value.value)));
  };
  if (useOnePanel) {
    return /*#__PURE__*/_jsxs(SinglePanelInputContainer, {
      children: [/*#__PURE__*/_jsx(SinglePanelOperatorSelectContainer, {
        size: width.size,
        children: /*#__PURE__*/_jsx(UISelect, {
          buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
          disabled: disabled,
          onSelectedOptionChange: handleOperatorTypeChange,
          options: options,
          readOnly: readOnly,
          value: !!condition.ignoreYear
        })
      }), /*#__PURE__*/_jsx(FilterOperatorRollingInequalityInput, Object.assign({}, props))]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(UISelect, {
        disabled: disabled,
        onSelectedOptionChange: handleOperatorTypeChange,
        options: options,
        readOnly: readOnly,
        value: !!condition.ignoreYear,
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
      })
    }), /*#__PURE__*/_jsx(FilterOperatorRollingInequalityInput, Object.assign({}, props))]
  });
};
export default /*#__PURE__*/memo(FilterOperatorRollingInequalityInputOperatorSelect);